<ng-template cellTemplate let-dataItem="dataItem">
    <div class="view">
        <div class="view-action">
            <fui-link-button (click)="openUrl(dataItem)" [title]="dataItem[field]"></fui-link-button>
        </div>
    </div>
</ng-template>
